export default abstract class ReportControl {
  classes: string;
  abstract render(key: string | number): JSX.Element;
}
